import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { WavyDivider } from "./WavyDivider";

export const PageHero = ({ title, breadcrumb, illustration, illustrationAlt = "" }) => (
  <section className="relative pt-10 pb-0">
    <div className="max-w-7xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-center">
      <div className="animate-fade-up">
        <h1 className="text-5xl md:text-6xl font-bold text-kid-navy">{title}</h1>
        <div className="mt-4 flex items-center gap-2 text-kid-navy/70">
          <Link to="/" className="hover:text-kid-amber" data-testid="breadcrumb-home">Home</Link>
          <ChevronRight size={16} />
          <span className="font-semibold">{breadcrumb}</span>
        </div>
      </div>
      {illustration && (
        <div className="flex justify-end">
          <img src={illustration} alt={illustrationAlt} className="max-h-72 object-contain animate-float" />
        </div>
      )}
    </div>
    <WavyDivider fromColor="#EEF0FB" toColor="#FFFFFF" className="mt-10" />
  </section>
);
